import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { customPaymentMethods, standardCheckoutRoutes } from "@jti/fe-common";
import { getCurrentMagentoClient } from "@jti/magento";
import { selectOrderNumber, useSelector } from "@jti/store";
import { Button, useTranslations } from "@jti/ui";
import { PayButton } from "../../../../components/PayButton";
import { useAemModel } from "../../../../contexts/AemModelContext";
import { useGtm } from "../../../../hooks/gtm/useGtm";
import { useFailedPaymentFlow } from "../../../../hooks/useFailedPaymentFlow";
import { useFreeTrial } from "../../../../hooks/useFreeTrial";
import usePaymentMethods from "../../../../hooks/usePaymentMethods";
import styles from "./PaymentPagePayButtons.module.scss";
export const PaymentPagePayButtons = forwardRef(({ isPolicyRead, paymentMethodCode, isPayOnDelivery, showPolicyCheck }, ref) => {
    const { orderId } = useParams();
    const history = useHistory();
    const { __ } = useTranslations();
    const { dispatchGtmAddPaymentInfo } = useGtm();
    const { isFreeTrial } = useFreeTrial();
    const { isPaymentMethodsListLoaded } = usePaymentMethods();
    const { failedPaymentFlow } = useAemModel();
    const { isFailedPaymentFlow } = useFailedPaymentFlow();
    const { data: orderDetailsData, fetchStatus: orderFetchStatus } = useSelector((state) => state.order.orderDetails);
    const deliveryStepData = useSelector((state) => state.standardCheckoutForm.deliveryStepData);
    const orderNumber = useSelector(selectOrderNumber(isFreeTrial));
    const { isPgsClientPending } = useSelector((state) => state.checkout);
    const [isProceed, setIsProceed] = useState(false);
    const magentoClient = getCurrentMagentoClient(isFreeTrial);
    const orderPaymentEntityId = deliveryStepData?.entityId || orderNumber;
    const retryPaymentButtonLabel = failedPaymentFlow?.retryPaymentButtonLabel || "";
    const buttonLabel = isFailedPaymentFlow && retryPaymentButtonLabel.length ? retryPaymentButtonLabel : __("cart.order.payment.pay");
    const sendGtmEvent = () => {
        if (!paymentMethodCode) {
            return;
        }
        dispatchGtmAddPaymentInfo(orderDetailsData, paymentMethodCode);
    };
    const finalizePayment = async () => {
        if (!orderPaymentEntityId) {
            return;
        }
        setIsProceed(true);
        try {
            await magentoClient.updatePaymentMethod(orderPaymentEntityId, customPaymentMethods.payOnDelivery);
            history.replace(standardCheckoutRoutes.order.getSummaryUrl(orderId));
        }
        catch (error) {
            setIsProceed(false);
        }
    };
    const handlePayButtonClick = () => {
        if (!isProceed) {
            setIsProceed(true);
        }
    };
    return isPayOnDelivery ? (_jsx(Button, { onClick: finalizePayment, isPending: isProceed || orderFetchStatus === "pending", "data-testid": "finalizePayment", className: styles.button, disabled: !isPolicyRead, color: "primary", children: __("cart.order.payment.finalize") })) : (_jsx("div", { onClick: sendGtmEvent, children: _jsx(PayButton, { ref: ref, onClick: handlePayButtonClick, isPending: isProceed || !isPaymentMethodsListLoaded || isPgsClientPending, "data-testid": "proceedToPayment", "data-pay-button": true, disabled: (showPolicyCheck && !isPolicyRead) || !isPaymentMethodsListLoaded || isPgsClientPending, color: "primary", children: buttonLabel }) }));
});
//# sourceMappingURL=PaymentPagePayButtons.js.map